import { compose } from "redux";
import { Set } from "immutable";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  GROUP_FORM,
  EDIT_LOCATION_GROUP_MODAL_ID,
} from "features/planner/planner.constants";

import MuiOilrigIcon from "app/components/MuiOilrigIcon";
import SimpleFormModal from "app/components/SimpleFormModal";
import { editLocationGroupOnSubmit } from "features/planner/planner.actions";
import LocationGroupForm from "features/planner/settings/locations/components/LocationGroupForm";

class EditLocationGroupModal extends PureComponent {
  render() {
    const { dispatchEditLocationGroupOnSubmit } = this.props;

    return (
      <SimpleFormModal
        submitText="Save"
        Icon={MuiOilrigIcon}
        title="Edit Location Group"
        component={LocationGroupForm}
        formTitleField={GROUP_FORM.NAME}
        modalId={EDIT_LOCATION_GROUP_MODAL_ID}
        onSubmit={dispatchEditLocationGroupOnSubmit}
        DialogProps={{
          maxWidth: "md",
        }}
        form={{
          form: GROUP_FORM.ID,
        }}
        FormProps={{
          visibleFields: Set(Object.values(GROUP_FORM)).delete(
            GROUP_FORM.FACILITY,
          ),
        }}
      />
    );
  }
}

export default compose(
  connect(null, {
    dispatchEditLocationGroupOnSubmit: editLocationGroupOnSubmit,
  }),
)(EditLocationGroupModal);
